import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import { SHOP_CATEGORIES } from "../lib/content";
import { FadeUp, PageHero } from "../components/Reveal";

export default function Shop() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  return (
    <main data-testid="shop-home">
      <PageHero
        eyebrow="The Online Shop"
        title="Shop Celtic Gold"
        sub="Discover jewellery, gifts and distinctive pieces inspired by the Isle of Man, Celtic heritage and timeless craftsmanship."
      />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 -mt-6 mb-16 relative z-10">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (q.trim()) navigate(`/shop/all?q=${encodeURIComponent(q.trim())}`);
          }}
          className="flex items-center gap-3 bg-ink-2 border border-gold/25 px-5 py-4"
        >
          <Search className="w-5 h-5 text-gold shrink-0" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search jewellery, gifts, collections..."
            data-testid="shop-search"
            className="flex-1 bg-transparent outline-none text-ivory placeholder:text-stone-mist/60 text-sm"
          />
          <button type="submit" data-testid="shop-search-submit" className="text-gold text-xs uppercase tracking-[0.25em] hover:text-gold-glow transition-colors">
            Search
          </button>
        </form>
      </div>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SHOP_CATEGORIES.map((cat, i) => (
            <FadeUp key={cat.slug} delay={i * 0.06} className={i === 1 ? "lg:row-span-2" : ""}>
              <Link
                to={cat.href || `/shop/${cat.slug}`}
                data-testid={`shop-category-${cat.slug}`}
                className={`group relative block overflow-hidden border border-white/5 hover:border-gold/40 transition-colors duration-700 ${
                  i === 1 ? "h-80 lg:h-full lg:min-h-[560px]" : "h-72"
                }`}
              >
                <img src={cat.image} alt={cat.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/35 to-transparent" />
                <div className="absolute bottom-0 p-7">
                  <h2 className="font-serif text-2xl lg:text-3xl text-ivory group-hover:text-gold transition-colors duration-500">{cat.name}</h2>
                  <p className="text-stone-mist text-sm font-light mt-2 max-w-xs">{cat.tagline}</p>
                  <span className="inline-flex items-center gap-2 text-gold text-[11px] uppercase tracking-[0.25em] mt-5">
                    Shop Now <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </main>
  );
}
